const runtimeConfig =
  typeof window !== "undefined" ? window.__RUNTIME_CONFIG__ || {} : {};

const getConfigValue = (key, fallback = "") => {
  const value = runtimeConfig[key];
  if (typeof value === "string" && value.trim() !== "") {
    return value;
  }
  return fallback;
};

export const API_URL = getConfigValue(
  "REACT_APP_API_URL",
  process.env.REACT_APP_API_URL || "",
);
export const IMAGE_DECHARGE_URL = getConfigValue(
  "REACT_APP_IMAGE_DECHARGE_URL",
  process.env.REACT_APP_IMAGE_DECHARGE_URL || "",
);
export const CURRENT_URL = getConfigValue(
  "REACT_APP_CURRENT_URL",
  process.env.REACT_APP_CURRENT_URL || "",
);

if (!API_URL || !IMAGE_DECHARGE_URL || !CURRENT_URL) {
  // Keep app booting, but make missing runtime config visible in browser logs.
  console.error(
    "Missing runtime config values. Check /env.js generation and Vault injection.",
  );
}
